/**
 * Returns the list payload from an API response that is either a bare array or
 * an object wrapping the array under `data` or the given `key`.
 */
export const getResponseArray = (
  responseData: unknown,
  key: string,
): unknown[] => {
  if (Array.isArray(responseData)) {
    return responseData;
  }

  if (!responseData || typeof responseData !== 'object') {
    return [];
  }

  const record = responseData as Record<string, unknown>;
  const wrapped = Array.isArray(record.data) ? record.data : record[key];
  return Array.isArray(wrapped) ? wrapped : [];
};

export default getResponseArray;
